import { useQuery } from '@tanstack/react-query';

import { Sampling } from 'src/shared/types/sampling';

import getProductSamplings from '../api/getProductSamplings';
import getDeliveredDate from '../utils/getDeliveredDate';

const useProductSamplings = (id: string) => {
  const query = useQuery({
    queryKey: ['product-samplings', id],
    queryFn: async () => {
      const response = await getProductSamplings(id);

      return response.data
        ?.map((item: Sampling) => ({
          ...item,
          type: item?.product_quote?.product_name,
          supplier_name: item?.cloak,
          delivered_date: getDeliveredDate(item)
        }))
        .filter((item: Sampling) => {
          if (item.stage === 'requested') {
            return false;
          }

          return true;
        })
        .sort((a: Sampling, b: Sampling) => {
          const aDate = Date.parse(a.requested_at);
          const bDate = Date.parse(b.requested_at);

          if (aDate === bDate) return 0;

          return aDate > bDate ? -1 : 1;
        });
    },
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};

export default useProductSamplings;
